/**
 * Ensures that a URL uses HTTPS in production
 * and handles protocol-relative URLs.
 */
export const ensureSecureUrl = (url) => {
    if (!url) return '';
    let resolvedUrl = url;
    if (typeof resolvedUrl === 'object' && resolvedUrl !== null) {
        resolvedUrl = resolvedUrl.url || resolvedUrl.src || resolvedUrl.path || '';
    }
    if (typeof resolvedUrl !== 'string') return '';
    
    // Handle protocol-relative URLs (starting with //)
    if (resolvedUrl.startsWith('//')) {
        return (typeof window !== 'undefined' && window.location?.protocol ? window.location.protocol : 'https:') + resolvedUrl;
    }
    
    // In production, force https if it's an absolute URL
    if (process.env.NODE_ENV === 'production' && resolvedUrl.startsWith('http://')) {
        return resolvedUrl.replace('http://', 'https://');
    }
    
    return resolvedUrl;
};

/**
 * Ensures that a link URL is absolute (starting with protocol or leading slash).
 */
export const ensureAbsoluteUrl = (url) => {
    if (!url) return '';
    let resolvedUrl = url;
    if (typeof resolvedUrl === 'object' && resolvedUrl !== null) {
        resolvedUrl = resolvedUrl.url || resolvedUrl.src || resolvedUrl.path || '';
    }
    if (typeof resolvedUrl !== 'string') return '';
    resolvedUrl = resolvedUrl.trim();
    if (!resolvedUrl) return '';

    if (
        resolvedUrl.startsWith('http://') ||
        resolvedUrl.startsWith('https://') ||
        resolvedUrl.startsWith('//') ||
        resolvedUrl.startsWith('mailto:') ||
        resolvedUrl.startsWith('tel:')
    ) {
        return ensureSecureUrl(resolvedUrl);
    }

    if (resolvedUrl.startsWith('/')) {
        return resolvedUrl;
    }

    return `https://${resolvedUrl}`;
};

export default {
    ensureSecureUrl,
    ensureAbsoluteUrl
};

